module.exports = __webpack_public_path__ + "static/img/Mastercard.7b19f8db.svg";